import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { extract } from '@app/core/i18n/i18n.service';
import { ReferralComponent } from './referral/referral.component';
import { InstructorDashboardComponent } from './referral-dashboard/instructor-dashboard/instructor-dashboard.component';

const routes: Routes = [
  { path: '', component: ReferralComponent, data: { title: extract('Referral') } },
  {
    path: 'instructor',
    component: InstructorDashboardComponent,
    data: { title: extract('Referral'), discriminantPathKey: 'REFERRAL' },
  },
  {
    path: 'referral-dashboard',
    loadChildren: () => import('./referral-dashboard/referral-dashboard.module').then((m) => m.ReferralDashboardModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  providers: [],
})
export class ReferralRoutingModule {}
